import { useTranslation } from "react-i18next";
import { useGetAgentEnumerations } from "../../../../common/api/queries/enumerations";
import type { UUID } from "../../../../typings/global";
import { formatAgentName } from "../../../agent/utils";

interface Props {
  id: UUID;
}

export const AgentEnumName = ({ id }: Props) => {
  const { t } = useTranslation();

  const { data, isFetched } = useGetAgentEnumerations([id]);
  const agent = data?.[0];

  if (!isFetched) {
    return null;
  }

  return agent ? <span>{formatAgentName(agent)}</span> : <span>{t("agent.helpers.unknownAgent")}</span>;
};
